<template>
  <div>
    <div
      v-for="item in currentItems"
      :key="item.uuid"
      class="d-flex align-center px-8"
    >
      {{ item.text }}
    </div>

    <transition-group name="slide-x-transition">
      <div
        v-for="item in missingItems"
        :key="item.uuid"
        :class="$style.missingBg"
        class="d-flex align-center red--text pl-2 "
      >
        <v-icon small color="red" class="pr-2">mdi-minus</v-icon>
        <span class="text-decoration-line-through">{{ item.text }}</span>
      </div>
    </transition-group>

    <transition-group name="slide-x-transition">
      <div
        v-for="item in newItems"
        :key="item.uuid"
        :class="$style.newBg"
        class="d-flex align-center primary--text pl-2"
      >
        <v-icon small color="primary" class="pr-2">mdi-alert-octagram</v-icon>
        {{ item.text }}
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'TrafficMessageRow',

  props: {
    items: Array
  },

  computed: {
    currentItems() {
      return this.items.filter(x => x.current)
    },

    newItems() {
      return this.items.filter(
        x => x.new && this.$route.name !== 'HistoryEvent'
      )
    },

    missingItems() {
      return this.items.filter(
        x => x.missing && this.$route.name !== 'HistoryEvent'
      )
    }
  }
}
</script>

<style lang="scss" module>
.newBg {
  background: rgba(#0034f9, 0.06);
}

.missingBg {
  background: rgba(red, 0.06);
}
</style>
